<template>
  <v-container v-if="perguntas.length > 0 && this.payload">
    <v-breadcrumbs
      v-if="isSala && !municipioIdProp"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <h2 class="mb-5">
      Inscrição {{ parceiro ? "do Parceiro " : "da Sala " }} -
      {{ municipio.nome }}/{{ municipio.uf }}
    </h2>

    <div v-if="this.statusRelatorio == 'Diagnóstico Enviado'">
      <div>
        <v-icon color="#fff">mdi-alert-circle</v-icon> Essa inscrição já foi
        finalizada
      </div>

      <v-btn
        color="laranja"
        class="ml-3"
        @click="downloadPdf"
        style="color: #fff"
      >
        PDF Inscrição
      </v-btn>
    </div>

    <!-- Aviso: Prazo terminou mas pode finalizar se começou -->
    <v-alert
      v-else-if="
        bloquearInscricoesNovas &&
        this.statusRelatorio != 'Diagnóstico em preenchimento'
      "
      type="warning"
      border="left"
      colored-border
      elevation="2"
      class="mb-4 aviso-compacto"
    >
      <div class="d-flex align-center">
        <div class="mr-3">
          <v-icon color="orange" size="28">mdi-clock-alert</v-icon>
        </div>
        <div class="flex-grow-1">
          <div class="font-weight-bold mb-1">
            Prazo encerrado em {{ dataFinal }}
          </div>
          <div class="text-caption">
            🎉 Boa notícia! Como você já iniciou, ainda pode finalizar sua
            inscrição.
            <span class="ml-2 text--secondary"
              >👁️ Sempre é possível visualizar as informações</span
            >
          </div>
        </div>
      </div>
    </v-alert>

    <!-- Aviso: Todas as inscrições bloqueadas -->
    <v-alert
      v-else-if="bloquearTodasInscricoes"
      type="error"
      border="left"
      colored-border
      elevation="2"
      class="mb-4 aviso-compacto"
    >
      <div class="d-flex align-center">
        <div class="mr-3">
          <v-icon color="red" size="28">mdi-lock-clock</v-icon>
        </div>
        <div class="flex-grow-1">
          <div class="font-weight-bold mb-1">
            Inscrições encerradas em {{ dataFinal }}
          </div>
          <div class="text-caption">
            Agradecemos seu interesse no Sistema Selo Sebrae 2026!
            <span class="ml-2 text--secondary"
              >Você ainda pode visualizar a inscrição</span
            >
          </div>
        </div>
      </div>
    </v-alert>

    <div v-else-if="isEnviada()" class="enviada">
      <div>
        <v-icon color="#fff">mdi-alert-circle</v-icon> Essa inscrição já foi
        finalizada
      </div>

      <div class="mt-3">
        <v-btn
          color="laranja"
          class="ml-3"
          @click="downloadPdf"
          style="color: #fff"
        >
          PDF Inscrição
        </v-btn>
      </div>
    </div>
    <v-form ref="form" v-if="podeContinuar">
      <div v-for="(grupo, i) in perguntas" :key="i" class="grupo">
        <template v-if="podeVerPergunta(grupo.children[0].perguntaId)">
          <div
            :class="` bloco`"
            @click="
              () => {
                grupo.close = !grupo.close;
                $forceUpdate();
              }
            "
          >
            {{ grupo.name }}
          </div>
          <template>
            <div
              v-for="(children, index) in grupo.children"
              :key="index"
              style="position: relative"
            >
              <template>
                <div
                  :style="
                    payload[children.grupoId][children.perguntaId].status ==
                    'loading'
                      ? 'opacity: 0.5'
                      : ''
                  "
                  class="children"
                  v-if="!children.dependente || mostrarDependente(children)"
                >
                  <div
                    v-html="children.preambulo"
                    class="subtitulo mb-4"
                    v-if="children.preambulo"
                  ></div>

                  <span class="numeration">{{ children.numero }}</span> -
                  {{ children.texto }}

                  <app-modal-show-evidence
                    :evidence="children.evidencia"
                    :color="'primary'"
                    v-if="children.evidencia"
                    :title="'Clique para saber mais'"
                    :isHtml="true"
                    :titulo="'Informação Importante'"
                  >
                  </app-modal-show-evidence>

                  <div
                    v-html="children.subtitulo"
                    class="subtitulo"
                    v-if="children.subtitulo"
                  ></div>

                  <div class="filho">
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-mask="['##:##-##:##']"
                      v-if="children.tipoResposta == tipoDiagnostico.intervalo"
                      placeholder="00:00-00:00"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesMaxIntervalo, rulesObg]
                          : [rulesMaxIntervalo]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-mask="['##:## às ##:## e ##:## às ##:##']"
                      hint="Formato: (00:00 às 00:00 e 00:00 às 00:00) ou (00:00 às 00:00)"
                      persistent-hint
                      v-if="
                        children.tipoResposta == tipoDiagnostico.intervaloDuplo
                      "
                      placeholder="00:00-00:00 às 00:00-00:00"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesMaxIntervaloDuplo, rulesObg]
                          : [rulesMaxIntervaloDuplo]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.telefone"
                      :placeholder="'(00) 0000-0000'"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesObg]
                          : [true]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-mask="['#####-###']"
                      v-if="children.tipoResposta == tipoDiagnostico.cep"
                      :placeholder="'00000-000'"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesMaxCep, rulesObg]
                          : [true]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-textarea
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.textArea"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-textarea>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.numero"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? rules
                          : [true]
                      "
                      type="number"
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.texto"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :disabled="isEnviada() || children.perguntaId == 8"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.link"
                      placeholder="Pressione Ctrl+V para colar o link aqui"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesLink, rulesObg]
                          : [rulesLink]
                      "
                      persistent-hint
                      hint="🔗 Este campo aceita apenas links colados (Ctrl+V). Digite a URL em outro lugar e cole aqui"
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @keydown="handleKeyDown($event, children)"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.email"
                      placeholder="Escreva aqui"
                      :rules="emailRules"
                      hide-details="auto"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-radio-group
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.boolean"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :disabled="
                        payload[children.grupoId][children.perguntaId].status ==
                          'loading' || isEnviada()
                      "
                      @change="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    >
                      <v-radio label="Sim" :key="1" :value="true"></v-radio>
                      <v-radio label="Não" :key="2" :value="false"></v-radio>
                    </v-radio-group>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      v-mascara="'##:##'"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? [rulesHoras, rulesObg]
                          : [rulesHoras]
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.horaMin"
                      hide-details="auto"
                      placeholder="hh:mm"
                      :name="`resposta${children.grupoId}${children.perguntaId}`"
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.perguntaId].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-autocomplete
                      v-if="children.tipoResposta == tipoDiagnostico.lista115"
                      v-model="
                        payload[children.grupoId][children.perguntaId].resposta
                      "
                      :ref="`resposta${children.grupoId}${children.perguntaId}`"
                      :items="[
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13',
                        '14',
                        '15',
                      ]"
                      placeholder="Selecione a quantidade"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.perguntaId]
                        )
                          ? rules
                          : [true]
                      "
                      @change="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.perguntaId}`,
                            i
                          );
                        }
                      "
                      :disabled="
                        payload[children.grupoId][children.perguntaId].status ==
                          'loading' || isEnviada()
                      "
                      :clearable="true"
                    >
                      <template slot="no-data">
                        Nenhum Ator retornado
                      </template>
                    </v-autocomplete>
                    <div
                      v-if="
                        children.tipoResposta ==
                        tipoDiagnostico.multiplasEscolhas
                      "
                      style="
                        display: flex;
                        column-gap: 10px;
                        flex-direction: column;
                      "
                    >
                      <div
                        style="display: flex; column-gap: 10px; flex-wrap: wrap"
                      >
                        <div
                          v-for="opcao in children.opcoesMultiplaEscolha"
                          :key="`${opcao}-${updateKey}`"
                        >
                          <v-checkbox
                            v-model="
                              checkboxStates[
                                `${children.grupoId}-${children.perguntaId}`
                              ]
                            "
                            :value="opcao"
                            :label="opcao"
                            :color="
                              isRulesNeeded(
                                children,
                                payload[children.grupoId][children.perguntaId]
                              ) &&
                              payload[children.grupoId][children.perguntaId]
                                .status === 'error' &&
                              !temAlgumaSelecao(children)
                                ? 'error'
                                : 'primary'
                            "
                            :error="
                              isRulesNeeded(
                                children,
                                payload[children.grupoId][children.perguntaId]
                              ) &&
                              payload[children.grupoId][children.perguntaId]
                                .status === 'error' &&
                              !temAlgumaSelecao(children)
                            "
                            :class="{
                              'checkbox-error':
                                isRulesNeeded(
                                  children,
                                  payload[children.grupoId][children.perguntaId]
                                ) &&
                                payload[children.grupoId][children.perguntaId]
                                  .status === 'error' &&
                                !temAlgumaSelecao(children),
                            }"
                            :ref="`resposta${children.grupoId}${children.perguntaId}`"
                            :disabled="
                              payload[children.grupoId][children.perguntaId]
                                .status == 'loading' || isEnviada()
                            "
                            :value-comparator="
                              (a, b) => String(a) === String(b)
                            "
                            @change="
                              () => {
                                handleCheckboxChangeModel(
                                  children,
                                  opcao,
                                  grupo,
                                  i
                                );
                              }
                            "
                            hide-details="auto"
                          />
                        </div>

                        <v-checkbox
                          v-model="
                            payload[children.grupoId][children.perguntaId]
                              .resposta
                          "
                          v-if="children.nomeCampoNaoMultiplaEscolha"
                          :value="children.nomeCampoNaoMultiplaEscolha"
                          :ref="`respostaEspecial${children.grupoId}${children.perguntaId}`"
                          :label="children.nomeCampoNaoMultiplaEscolha"
                          :color="
                            isRulesNeeded(
                              children,
                              payload[children.grupoId][children.perguntaId]
                            ) &&
                            payload[children.grupoId][children.perguntaId]
                              .status === 'error' &&
                            !temAlgumaSelecao(children)
                              ? 'error'
                              : 'primary'
                          "
                          :error="
                            isRulesNeeded(
                              children,
                              payload[children.grupoId][children.perguntaId]
                            ) &&
                            payload[children.grupoId][children.perguntaId]
                              .status === 'error' &&
                            !temAlgumaSelecao(children)
                          "
                          :class="{
                            'checkbox-error':
                              isRulesNeeded(
                                children,
                                payload[children.grupoId][children.perguntaId]
                              ) &&
                              payload[children.grupoId][children.perguntaId]
                                .status === 'error' &&
                              !temAlgumaSelecao(children),
                          }"
                          :disabled="
                            payload[children.grupoId][children.perguntaId]
                              .status == 'loading' || isEnviada()
                          "
                          :value-comparator="(a, b) => String(a) === String(b)"
                          @change="
                            () => {
                              handleCheckboxChangeDireto(
                                children,
                                children.nomeCampoNaoMultiplaEscolha,
                                grupo,
                                i,
                                true
                              );
                            }
                          "
                          hide-details="auto"
                        />
                      </div>

                      <!-- Mensagem de erro para validação de checkbox obrigatório -->
                      <div
                        v-if="
                          isRulesNeeded(
                            children,
                            payload[children.grupoId][children.perguntaId]
                          ) &&
                          payload[children.grupoId][children.perguntaId]
                            .status === 'error' &&
                          !temAlgumaSelecao(children)
                        "
                        class="v-messages theme--light error--text"
                        style="margin-top: 10px"
                      >
                        <div class="v-messages__wrapper">
                          <div
                            class="v-messages__message"
                            style="color: #ff5252; font-size: 12px"
                          >
                            É necessário selecionar pelo menos uma opção
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style="width: 100%"
                      v-if="
                        children.tipoResposta == tipoDiagnostico.arquivo ||
                        children.tipoResposta == tipoDiagnostico.video
                      "
                    >
                      <v-file-input
                        :rules="[
                          children.obrigatorio &&
                          payload[children.grupoId][children.perguntaId].files
                            .length != children.quantidadePermitida
                            ? rulesObg
                            : true,
                        ]"
                        :name="`resposta${children.grupoId}${children.perguntaId}`"
                        :ref="`resposta${children.grupoId}${children.perguntaId}`"
                        :accept="children.tipoExtensaoPermitida"
                        placeholder="Selecione o arquivo"
                        v-model="
                          payload[children.grupoId][children.perguntaId]
                            .resposta
                        "
                        v-if="!isEnviada()"
                        :disabled="
                          payload[children.grupoId][children.perguntaId]
                            .status == 'loading' ||
                          payload[children.grupoId][children.perguntaId].files
                            .length == children.quantidadePermitida ||
                          isEnviada()
                        "
                        :hint="`Quantidade de arquivos:
                    ${children.quantidadePermitida} `"
                        persistent-hint
                        @change="
                          () => {
                            save(
                              children,
                              grupo,
                              `resposta${children.grupoId}${children.perguntaId}`,
                              i,
                              true
                            );
                          }
                        "
                      >
                      </v-file-input>

                      <div
                        v-if="
                          isEnviada() &&
                          payload[children.grupoId][children.perguntaId].files
                            .length == 0
                        "
                        style="font-size: 14px; margin: 5px 26px; opacity: 0.5"
                      >
                        Nenhum arquvio enviado
                      </div>
                      <div
                        style="
                          display: flex;
                          row-gap: 20px;
                          flex-direction: column;
                          margin: 0 10px;
                          z-index: 1;
                          position: relative;
                          margin-top: 1rem;
                        "
                        v-if="
                          payload[children.grupoId][children.perguntaId]
                            .files &&
                          payload[children.grupoId][children.perguntaId].files
                            .length > 0
                        "
                      >
                        <div
                          style="color: #2d6189"
                          v-for="(file, index) in payload[children.grupoId][
                            children.perguntaId
                          ].files"
                          :key="index"
                        >
                          <span
                            style="cursor: pointer"
                            @click="
                              downloadEvidencia(
                                file.evidenciaId,
                                children,
                                payload[children.grupoId][children.perguntaId]
                              )
                            "
                            >{{ file.filename }}</span
                          >
                          <v-btn
                            outlined
                            color="error"
                            class="ml-3"
                            v-if="!isEnviada()"
                            @click="
                              deleteFile(
                                file.evidenciaId,
                                payload[children.grupoId][children.perguntaId]
                              )
                            "
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div class="status">
                      <template>
                        <div
                          class="salvar"
                          v-if="
                            payload[children.grupoId][children.perguntaId]
                              .status == 'success'
                          "
                        >
                          <v-icon color="#0c6b10"
                            >mdi-checkbox-marked-circle</v-icon
                          >
                          Salvo
                        </div>

                        <div
                          class="salvarErro"
                          v-if="
                            payload[children.grupoId][children.perguntaId]
                              .status == 'error'
                          "
                        >
                          <v-icon color="#FF5252">mdi-block-helper</v-icon>
                          Não Salvo
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <div
                v-if="
                  payload[children.grupoId][children.perguntaId].status ==
                  'loading'
                "
                style="position: absolute; left: 50%; top: 29%; z-index: 1"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div
        class="buttons"
        style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap"
      >
        <v-btn
          color="laranja"
          @click="back()"
          style="color: #fff"
          v-if="!municipioIdProp"
        >
          {{ !isEnviada() ? "Salvar e sair" : "voltar" }}
        </v-btn>
        <v-btn
          color="azulclarosc"
          @click="enviarAnalise"
          v-if="!isEnviada() && possuiResponsavel"
          style="color: #fff"
        >
          Finalizar inscrição
        </v-btn>
        <div v-if="!isEnviada() && !possuiResponsavel" style="width: 100%">
          <v-card
            outlined
            elevation="2"
            style="
              border-radius: 12px;
              border: 2px solid #2196f3;
              overflow: hidden;
            "
          >
            <!-- Área de informação -->
            <div
              style="
                background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
                padding: 20px;
                border-bottom: 2px solid #2196f3;
              "
            >
              <div style="display: flex; align-items: start; gap: 15px">
                <div
                  style="
                    background: #2196f3;
                    border-radius: 50%;
                    width: 48px;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
                  "
                >
                  <v-icon color="white" size="26">mdi-email-outline</v-icon>
                </div>
                <div style="flex: 1">
                  <div
                    style="
                      font-weight: 700;
                      color: #1565c0;
                      font-size: 16px;
                      margin-bottom: 8px;
                      letter-spacing: 0.3px;
                    "
                  >
                    📧 Importante: Verifique o e-mail do responsável pela sala
                    do empreendedor antes de continuar.
                  </div>
                  <div
                    style="font-size: 14px; color: #424242; line-height: 1.7"
                  >
                    Ao clicar em <strong>Iniciar inscrição</strong>, será
                    enviado um <strong>código de confirmação</strong> para o
                    e-mail do
                    <strong>Responsável pela Sala do Empreendedor</strong>. Após
                    validar o código, o usuário deverá criar uma
                    <strong>senha</strong> para acessar a inscrição, que ficará
                    vinculada <strong>exclusivamente</strong> a esse e-mail.
                  </div>
                </div>
              </div>
            </div>

            <!-- Área do botão -->
            <div
              style="
                padding: 20px;
                background: white;
                width: fit-content;
                margin: auto;
              "
            >
              <v-btn
                color="azulclarosc"
                @click="avisoIniciarInscricao"
                style="color: #fff"
                x-large
                block
                elevation="3"
              >
                <v-icon left size="24">mdi-email-check-outline</v-icon>
                Iniciar inscrição
              </v-btn>
            </div>
          </v-card>
        </div>
      </div>
    </v-form>
    <div v-else-if="!isLoading">
      <v-card
        class="mx-auto mt-8"
        max-width="600"
        elevation="8"
        style="border-radius: 15px"
      >
        <v-card-text class="text-center py-8">
          <v-icon color="#2d6189" size="64" class="mb-4">
            mdi-account-lock
          </v-icon>

          <h2 class="mb-4" style="color: #2d6189; font-weight: 600">
            🔐 Acesso Restrito
          </h2>

          <p
            class="mb-6"
            style="font-size: 16px; color: #555; line-height: 1.6"
          >
            Esta inscrição já possui um responsável cadastrado.<br />
            Para continuar o preenchimento, é necessário fazer login.
          </p>

          <v-divider class="mb-6"></v-divider>

          <v-btn
            color="#2d6189"
            large
            rounded
            elevation="4"
            style="color: white; font-weight: 600; padding: 0 30px"
            @click="irParaLogin"
          >
            <v-icon left>mdi-login</v-icon>
            Fazer Login
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import tipoDiagnosticoEnum from "../tipoDiagnostico";

import { cityAPI } from "@/modules/city";
import moment from "moment";

import { seloDiagnosticoPerguntasAPI } from "../API/seloDiagnosticoPerguntasAPI";
import { seloDiagnosticoRespostaAPI } from "../API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoEvidenciasAPI } from "../API/seloDiagnosticoEvidenciasAPI";

import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";

import * as tus from "tus-js-client";
import Swal from "sweetalert2";
import { configuracoesAPI } from "@/modules/configuracao";
import { userAPI } from "@/modules/user/components/UserAPI";
import Auth from "@/Auth.js";
import { groupsPermissionAPI } from "@/modules/groups";

export default {
  components: {
    AppModalShowEvidence,
  },
  props: {
    municipioIdProp: { type: Number | null },
    uf: { type: String | null },
    parceiro: { type: Boolean | null },
    dataFinal: { type: String | null },
  },
  data() {
    return {
      payload: {},
      previousValues: {}, // Valores anteriores para evitar saves desnecessários
      headers: [],
      idPerguntasSemResponsavel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      municipio: {},
      tiposCampoMapeados: {},
      closeGrupos: {},
      allRespostas: [],
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/geral`,
          exact: true,
        },
        {
          text: "Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/diagnostic/selo`,
          exact: true,
        },
      ],
      municipioId: this.municipioIdProp || this.$route.params.id,
      updateKey: 0, // Para forçar re-renderização
      rulesHoras: (v) => {
        if (!this.horaRegex.test(v)) {
          return "Hora inválida";
        }
        return true;
      },
      rulesMaxIntervalo: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 11) {
          return "Intervalo inválido";
        }
        return true;
      },
      rulesMaxIntervaloDuplo: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 31 && v.length != 14) {
          return "Intervalo inválido";
        }
        return true;
      },
      rulesMaxCep: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 9) {
          return "CEP inválido";
        }
        return true;
      },
      rulesTelCep: (v) => {
        if (v && v.length < 13) {
          return "Telefone inválido";
        }
        return true;
      },
      rulesLink: (v) => {
        if (
          v &&
          !/^(https?:\/\/)?([\w.-]+\.[\w]{2,})(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/.test(
            v
          )
        ) {
          return "O link informado é inválido. Verifique se o endereço foi copiado corretamente e tente novamente.";
        }
        return true;
      },
      rulesObg: (v) => {
        if (v === false) {
          return true;
        }
        // eslint-disable-next-line eqeqeq
        if (v == "" || !v) {
          return "Campo Obrigatório";
        }
        return true;
      },

      rulesCheckboxObg: (children) => {
        // Regra para validar se pelo menos um checkbox foi selecionado
        const checkboxStates =
          this.checkboxStates[`${children.grupoId}-${children.perguntaId}`] ||
          [];
        const payloadResposta =
          this.payload[children.grupoId] &&
          this.payload[children.grupoId][children.perguntaId]
            ? this.payload[children.grupoId][children.perguntaId].resposta
            : null;

        // Verificar se há seleções no v-model dos checkboxes normais
        const temSelecaoNormal = checkboxStates.length > 0;

        // Verificar se há seleção no checkbox especial (nomeCampoNaoMultiplaEscolha)
        const temSelecaoEspecial = Array.isArray(payloadResposta)
          ? payloadResposta.includes(children.nomeCampoNaoMultiplaEscolha)
          : payloadResposta === children.nomeCampoNaoMultiplaEscolha;

        if (!temSelecaoNormal && !temSelecaoEspecial) {
          return "É necessário selecionar pelo menos uma opção";
        }

        return true;
      },

      rulesFile: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 7000000
            ? "Total de arquivos não pode ser maior que 5MB!"
            : true;
        }

        return !files;
      },
      rulesVideo: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 30000000
            ? "Total de arquivos não pode ser maior que 30MB!"
            : true;
        }

        return !files;
      },
      horaRegex: /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/,
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      rules: [
        (v) => {
          if (v === false) {
            return true;
          }
          // eslint-disable-next-line eqeqeq
          if (v == "" || !v) {
            return "Campo Obrigatório";
          }
          return true;
        },
      ],
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      user: JSON.parse(localStorage.getItem("user") || {}),
      perguntas: [],
      tipoDiagnostico: tipoDiagnosticoEnum,
      allPerguntas: [],
      idPerguntaCoringa: 121,
      bloquearTodasInscricoes: false,
      bloquearInscricoesNovas: false,
      statusRelatorio: null,
      podeContinuar: false,
      checkboxStatesData: {}, // Para armazenar estados dos checkboxes
    };
  },
  watch: {
    async municipioIdProp(val) {
      this.municipioId = val;
      if (this.bloquearInscricoesNovas) {
        const status = await seloDiagnosticoPerguntasAPI.getSituacaoDiagnostico(
          val,
          this.uf,
          this.parceiro
        );

        this.statusRelatorio =
          (status.data && status.data.length > 0 && status.data[0].situacao) ||
          null;
      }

      this.filteredItems();
    },
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setForcedLogout",
      "setFullAdmin",
      "setToken",
      "setUser",
      "setConfig",
      "setGroupsConfig",
    ]),
    downloadPdf() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .downloadPdf(this.municipioId, this.uf, this.parceiro)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Inscrição - ${this.municipio.nome} - ${
            this.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },
    // Helper method para verificar se opção está selecionada com comparação consistente
    isOpcaoSelecionadaHelper(children, opcao) {
      const key = `${children.grupoId}-${children.perguntaId}`;
      const estados = this.checkboxStates[key] || [];
      const resultado = estados.some((item) => String(item) === String(opcao));

      return resultado;
    },
    podeVerPergunta(perguntaId) {
      if (!this.isAuthenticated || !this.possuiResponsavel)
        return this.idPerguntasSemResponsavel.includes(perguntaId);
      else return true;
    },
    aparecerAbaixoPerguntaCoringa(perguntaId) {
      if (this.parceiro) this.idPerguntaCoringa = 122;

      if (perguntaId > 158) return true;

      const pergunta = this.allPerguntas.filter(
        (p) => p.perguntaId == this.idPerguntaCoringa
      )[0];
      const resposta = this.payload[pergunta.grupoId][pergunta.perguntaId];

      if (resposta && resposta.resposta) {
        return true;
      }

      if (perguntaId > this.idPerguntaCoringa) {
        return false;
      } else {
        return true;
      }
    },
    statusPreGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      if (
        valoresGrupo.some((item) => {
          // eslint-disable-next-line eqeqeq
          return item.status == "error";
        })
      ) {
        this.perguntas[index].status = "error";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mostrarDependente(children) {
      if (children.respostaDependente == 1) {
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta
        );
      }

      if (children.respostaDependente == 0)
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta === false
        );
    },
    statusGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);

      if (this.grupoCompleto(grupo)) {
        this.perguntas[index].status = "completed";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mapRespostas() {
      seloDiagnosticoRespostaAPI
        .list(this.municipioId, this.uf, this.parceiro)
        .then((item) => {
          let resposta = item.data;
          this.allRespostas = item.data;

          let a =
            resposta.reduce(function (rv, x) {
              rv[x["perguntaGrupoId"]] = { ...rv[x["perguntaGrupoId"]] };
              if (!x.nomeArquivo) {
                rv[x["perguntaGrupoId"]][x["perguntaId"]] = x;
              } else {
                if (rv[x["perguntaGrupoId"]][x["perguntaId"]]) {
                  rv[x["perguntaGrupoId"]][x["perguntaId"]] = [
                    ...rv[x["perguntaGrupoId"]][x["perguntaId"]],
                    x,
                  ];
                } else rv[x["perguntaGrupoId"]][x["perguntaId"]] = [x];
              }

              return rv;
            }, {}) || {};

          const tipoDiagnosticoRef = this.tipoDiagnostico;

          this.payload = this.allPerguntas.reduce(function (rv, x) {
            if (
              x.tipoNome.toLowerCase().indexOf("arquivo") > -1 ||
              x.tipoNome.toLowerCase().indexOf("video") > -1
            ) {
              if (!rv[x["grupoId"]]) {
                rv[x["grupoId"]] = {};
              }
              if (!a[x["grupoId"]]) {
                a[x["grupoId"]] = {};
              }

              if (!a[x["grupoId"]][x["perguntaId"]]) {
                rv[x["grupoId"]][x["perguntaId"]] = {
                  resposta: null,
                  files: [],
                };
              } else {
                rv[x["grupoId"]][x["perguntaId"]] = {
                  ...a[x["grupoId"]][x["perguntaId"]][0],
                  resposta: null,
                  status: "",
                  files: a[x["grupoId"]][x["perguntaId"]].map((item) => ({
                    filename: item.nomeArquivo,
                    url: item.url,
                    evidenciaId: item.evidenciaId,
                  })),
                };
              }
            } else {
              if (!a[x["grupoId"]] && !rv[x["grupoId"]]) {
                a[x["grupoId"]] = { ...a[x["grupoId"]] };
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                rv[x["grupoId"]][x["perguntaId"]] = {
                  resposta:
                    x.tipoResposta == tipoDiagnosticoRef.multiplasEscolhas
                      ? []
                      : null,
                };
              } else if (a[x["grupoId"]] && !rv[x["grupoId"]]) {
                if (
                  a[x["grupoId"]][x["perguntaId"]] &&
                  a[x["grupoId"]][x["perguntaId"]].resposta == "true"
                ) {
                  a[x["grupoId"]][x["perguntaId"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (
                  a[x["grupoId"]][x["perguntaId"]] &&
                  a[x["grupoId"]][x["perguntaId"]].resposta == "false"
                ) {
                  a[x["grupoId"]][x["perguntaId"]].resposta = false;
                }

                rv[x["grupoId"]] = {};
                rv[x["grupoId"]][x["perguntaId"]] = (a[x["grupoId"]][
                  x["perguntaId"]
                ] && {
                  ...a[x["grupoId"]][x["perguntaId"]],
                  status: "",
                }) || { resposta: null };
              } else if (!a[x["grupoId"]][x["perguntaId"]]) {
                rv[x["grupoId"]][x["perguntaId"]] = { resposta: null };
              } else {
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["perguntaId"]].resposta == "true") {
                  a[x["grupoId"]][x["perguntaId"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["perguntaId"]].resposta == "false") {
                  a[x["grupoId"]][x["perguntaId"]].resposta = false;
                }

                // Converter string de múltiplas escolhas de volta para array
                if (
                  x.tipoResposta == tipoDiagnosticoRef.multiplasEscolhas &&
                  a[x["grupoId"]][x["perguntaId"]].resposta &&
                  typeof a[x["grupoId"]][x["perguntaId"]].resposta === "string"
                ) {
                  a[x["grupoId"]][x["perguntaId"]].resposta = a[x["grupoId"]][
                    x["perguntaId"]
                  ].resposta
                    .split(", ")
                    .filter((item) => item.trim().length > 0);
                }

                rv[x["grupoId"]][x["perguntaId"]] = {
                  ...a[x["grupoId"]][x["perguntaId"]],
                  status: "",
                };
              }
            }

            return rv;
          }, {});

          Object.keys(this.payload).forEach((grupoId) => {
            Object.keys(this.payload[grupoId]).forEach((perguntaId) => {
              const item = this.payload[grupoId][perguntaId];
              if (Array.isArray(item.resposta)) {
              }
            });
          });
          if (!this.isEnviada()) {
            this.payload[2][8].resposta = this.municipio.nome;

            const save = {
              municipioId: this.municipioId,
              usuarioId: this.municipioIdProp ? 0 : this.user.usuarioId,
              perguntaId: 8,
              dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
              resposta: this.municipio.nome,
              respostaId: this.payload[2][8].respostaId,
              respondida: true,
              perguntaGrupoId: 2,
              uf: this.uf,
              parceiro: this.parceiro,
            };

            seloDiagnosticoRespostaAPI.atualizar(save).then(() => {});
          }

          // Inicializar previousValues com os valores atuais do payload
          this.initializePreviousValues();

          // Inicializar previousValues com os valores atuais do payload
          this.initializePreviousValues();

          this.$forceUpdate();
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter respostas");

          console.log("mapRespostas err: ", err);
          this.setLoading(false);
        });
    },
    initializePreviousValues() {
      // Inicializar previousValues com os valores atuais do payload
      Object.keys(this.payload).forEach((grupoId) => {
        Object.keys(this.payload[grupoId]).forEach((perguntaId) => {
          const chave = `${grupoId}_${perguntaId}`;
          const valor = this.payload[grupoId][perguntaId].resposta;
          this.previousValues[chave] = JSON.stringify(valor);
        });
      });
    },
    getOptions(file) {
      return {
        endpoint:
          "https://api.cloudflare.com/client/v4/accounts/e2f8a6cba3853a64e90ed0683c02e9c8/stream",
        headers: {
          Authorization: "Bearer gUgZlz0PyIrgJA1SyZd6s-cVsLQv-3fMqu-6IQNU",
        },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000], // Indicates to tus-js-client the delays after which it will retry if the upload fails
        metadata: {
          filename: file.name,
          filetype: file.type,
        },
      };
    },
    handleMultiplaEscolhaChange(
      children,
      valorClicado,
      isEspecial,
      grupo,
      index
    ) {
      const respostaAtual =
        this.payload[children.grupoId][children.perguntaId].resposta || [];

      if (isEspecial) {
        // Clicou no campo especial (Não se aplica)
        if (respostaAtual.includes(valorClicado)) {
          // Já estava selecionado, remover
          this.payload[children.grupoId][children.perguntaId].resposta = [];
        } else {
          // Limpar todas as opções e selecionar só o especial
          this.payload[children.grupoId][children.perguntaId].resposta = [
            valorClicado,
          ];
        }
      } else {
        // Clicou em opção normal
        let novaResposta = Array.isArray(respostaAtual)
          ? [...respostaAtual]
          : [respostaAtual];

        // Remover campo especial se existir
        const indexEspecial = novaResposta.indexOf(
          children.nomeCampoNaoMultiplaEscolha
        );

        if (indexEspecial > -1) {
          novaResposta.splice(indexEspecial, 1);
        }

        // Adicionar/remover a opção clicada
        const indexOpcao = novaResposta.indexOf(valorClicado);
        if (indexOpcao > -1) {
          novaResposta.splice(indexOpcao, 1);
        } else {
          novaResposta.push(valorClicado);
        }

        this.payload[children.grupoId][children.perguntaId].resposta =
          novaResposta;
      }

      this.$forceUpdate();

      // Salvar após mudança
      this.save(
        children,
        grupo,
        `resposta${children.grupoId}${children.perguntaId}`,
        index
      );
    },
    getResposta(children) {
      if (
        !this.payload ||
        !this.payload[children.grupoId] ||
        !this.payload[children.grupoId][children.perguntaId]
      ) {
        return [];
      }
      const resposta =
        this.payload[children.grupoId][children.perguntaId].resposta;
      return Array.isArray(resposta) ? resposta : [];
    },
    isOpcaoSelecionada(children, opcao) {
      if (
        !this.payload ||
        !this.payload[children.grupoId] ||
        !this.payload[children.grupoId][children.perguntaId]
      ) {
        return false;
      }

      const resposta =
        this.payload[children.grupoId][children.perguntaId].resposta;

      if (!Array.isArray(resposta)) {
        return false;
      }

      const resultado = resposta.includes(opcao);

      return resultado;
    },
    handleCheckboxChangeDireto(
      children,
      valor,
      grupo,
      index,
      isEspecial = false
    ) {
      // Obter resposta atual
      let resposta =
        this.payload[children.grupoId][children.perguntaId].resposta;
      if (typeof resposta === "string" && resposta.trim()) {
        resposta = resposta
          .split(", ")
          .filter((item) => item.trim().length > 0);
      }
      if (!Array.isArray(resposta)) {
        resposta = [];
      }

      // Se é o campo especial e foi marcado, limpar todas as outras opções
      if (isEspecial && resposta.includes(valor)) {
        resposta = [valor]; // Manter apenas o campo especial
      }

      // Atualizar array
      this.$set(
        this.payload[children.grupoId][children.perguntaId],
        "resposta",
        resposta
      );

      // Salvar após mudança
      this.$nextTick(() => {
        this.save(
          children,
          grupo,
          `resposta${children.grupoId}${children.perguntaId}`,
          index
        );
      });
    },
    handleCheckboxChangeModel(
      children,
      valor,
      grupo,
      index,
      isEspecial = false
    ) {
      // Obter array atual do v-model
      let arrayAtual =
        this.checkboxStates[`${children.grupoId}-${children.perguntaId}`] || [];

      // Se clicou em uma opção normal, remover o campo especial se existir
      if (
        children.nomeCampoNaoMultiplaEscolha &&
        arrayAtual.includes(children.nomeCampoNaoMultiplaEscolha)
      ) {
        arrayAtual = arrayAtual.filter(
          (item) => item !== children.nomeCampoNaoMultiplaEscolha
        );
      }

      // Atualizar o payload baseado no v-model (já sem o campo especial)
      this.$set(
        this.payload[children.grupoId][children.perguntaId],
        "resposta",
        [...arrayAtual]
      );

      // Salvar após mudança
      this.$nextTick(() => {
        this.save(
          children,
          grupo,
          `resposta${children.grupoId}${children.perguntaId}`,
          index
        );
      });
    },
    handleCheckboxChange(children, valor, checked, isEspecial, grupo, index) {
      // Garantir que a estrutura existe
      if (
        !this.payload[children.grupoId] ||
        !this.payload[children.grupoId][children.perguntaId]
      ) {
        return;
      }

      // Garantir que seja sempre um array para múltiplas escolhas
      let respostaAtual =
        this.payload[children.grupoId][children.perguntaId].resposta;

      // Se é string (veio do backend como "MEI, Microempresa"), converter para array
      if (typeof respostaAtual === "string" && respostaAtual.trim()) {
        respostaAtual = respostaAtual
          .split(", ")
          .filter((item) => item.trim().length > 0);
      }

      // Se não é array, inicializar como array vazio
      if (!Array.isArray(respostaAtual)) {
        respostaAtual = [];
      }

      // Criar novo array (Vue detecta melhor mudanças em objetos novos)
      let novaResposta = [...respostaAtual];

      if (isEspecial) {
        novaResposta = checked ? [valor] : [];
      } else {
        if (checked) {
          // Remover campo especial se existir
          const indexEspecial = novaResposta.indexOf(
            children.nomeCampoNaoMultiplaEscolha
          );
          if (indexEspecial > -1) {
            novaResposta.splice(indexEspecial, 1);
          }

          // Adicionar se não existir
          if (!novaResposta.includes(valor)) {
            novaResposta.push(valor);
          }
        } else {
          // Remover valor
          const index = novaResposta.indexOf(valor);
          if (index > -1) {
            novaResposta.splice(index, 1);
          }
        }
      }

      // Usar $set para garantir reatividade
      this.$set(
        this.payload[children.grupoId][children.perguntaId],
        "resposta",
        novaResposta
      );

      // Incrementar key para forçar re-render
      this.updateKey++;

      // Forçar Vue a re-renderizar
      this.$forceUpdate();

      // Salvar após Vue processar mudanças
      this.$nextTick(() => {
        this.save(
          children,
          grupo,
          `resposta${children.grupoId}${children.perguntaId}`,
          index
        );
      });
    },
    save(children, grupo, nomeForm, index, isFile) {
      if (
        this.bloquearInscricoesNovas &&
        this.statusRelatorio != "Diagnóstico em preenchimento"
      ) {
        return;
      }

      if (this.bloquearTodasInscricoes) {
        return;
      }

      // Verificar se o valor mudou
      const chave = `${children.grupoId}_${children.perguntaId}`;
      const valorAtual = JSON.stringify(
        this.payload[children.grupoId][children.perguntaId].resposta
      );

      if (this.previousValues[chave] === valorAtual && !isFile) {
        return; // Valor não mudou
      }

      this.previousValues[chave] = valorAtual;

      // eslint-disable-next-line eqeqeq
      if (
        this.payload[children.grupoId][children.perguntaId].status == "loading"
      ) {
        return;
      }

      this.$forceUpdate();

      // Para múltiplas escolhas, validar se pelo menos uma opção foi selecionada
      if (children.tipoResposta == this.tipoDiagnostico.multiplasEscolhas) {
        // Validar se é obrigatório e se pelo menos uma opção foi selecionada
        if (
          this.isRulesNeeded(
            children,
            this.payload[children.grupoId][children.perguntaId]
          )
        ) {
          // Usar o método temAlgumaSelecao para validar
          if (!this.temAlgumaSelecao(children)) {
            this.payload[children.grupoId][children.perguntaId].status =
              "error";
            this.statusPreGrupo(grupo, index);
            this.$forceUpdate();
            return;
          }
        }
      } else {
        // Para outros tipos, usar validação normal

        if (!this.$refs[nomeForm] || !this.$refs[nomeForm][0]) {
          return;
        }

        const refName = this.$refs[nomeForm][0];
        const valid = refName.validate();
        if (!valid) {
          this.payload[children.grupoId][children.perguntaId].status = "error";
          this.statusPreGrupo(grupo, index);
          this.$forceUpdate();
          return;
        }
      }

      // Converter resposta para string se for múltiplas escolhas
      let respostaParaSalvar =
        this.payload[children.grupoId][children.perguntaId].resposta;
      if (
        children.tipoResposta == this.tipoDiagnostico.multiplasEscolhas &&
        Array.isArray(respostaParaSalvar)
      ) {
        respostaParaSalvar = respostaParaSalvar.join(", ");
      }

      const save = {
        municipioId: this.municipioId,
        usuarioId: this.municipioIdProp ? 0 : this.user.usuarioId,
        perguntaId: children.perguntaId,
        dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
        resposta: isFile ? "" : respostaParaSalvar,
        respostaId:
          this.payload[children.grupoId][children.perguntaId].respostaId,
        respondida: true,
        enviada: false,
        perguntaGrupoId: children.grupoId,
        uf: this.uf,
        parceiro: this.parceiro,
      };
      console.log("Dados da inscrição: ", save);

      if (isFile) {
        this.setLoading(true);
        if (!this.payload[children.grupoId][children.perguntaId].resposta) {
          this.setLoading(false);

          return;
        }
      }

      if (
        this.payload[children.grupoId][children.perguntaId].perguntaId == 3 &&
        this.isAuthenticated
      ) {
        console.log("Iniciando inscrição para o município: ", this.municipioId);

        this.avisoIniciarInscricao(save, isFile, children, grupo, index);
      } else {
        this.atualizar(save, isFile, children, grupo, index);
      }
    },
    atualizar(save, isFile, children, grupo, index) {
      seloDiagnosticoRespostaAPI
        .atualizar(save)
        .then(async ({ data }) => {
          if (isFile) {
            var file =
              this.payload[children.grupoId][children.perguntaId].resposta;
            if (
              Array.isArray(
                this.payload[children.grupoId][children.perguntaId].resposta
              )
            ) {
              file =
                this.payload[children.grupoId][children.perguntaId].resposta[0];
            }

            if (file.type.indexOf("video") > -1) {
              const minhaPromise = new Promise((resolve, reject) => {
                var upload = new tus.Upload(file, {
                  ...this.getOptions(file, children),
                  onError: function (error) {
                    console.log("error: ", error);
                    throw error;
                  },
                  // onProgress: function (bytesUploaded, bytesTotal) {
                  //   var percentage = (
                  //     (bytesUploaded / bytesTotal) *
                  //     100
                  //   ).toFixed(2)
                  // },
                  onSuccess: function () {
                    resolve(upload);
                  },
                });

                upload.start();
              });
              let formData = new FormData();

              const val = await minhaPromise;

              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);
              formData.append("url", val.url);
              formData.append("nomeArquivo", val.file.name);
              formData.append("uf", this.uf);
              formData.append("parceiro", this.parceiro);

              seloDiagnosticoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.perguntaId].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            } else {
              let formData = new FormData();

              if (
                Array.isArray(
                  this.payload[children.grupoId][children.perguntaId].resposta
                )
              ) {
                for (
                  let i = 0;
                  i <
                  this.payload[children.grupoId][children.perguntaId].resposta
                    .length;
                  i++
                ) {
                  formData.append(
                    "arquivo",
                    this.payload[children.grupoId][children.perguntaId]
                      .resposta[i]
                  );
                }
              } else {
                formData.append(
                  "arquivo",
                  this.payload[children.grupoId][children.perguntaId].resposta
                );
              }
              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);
              formData.append("uf", this.uf);
              formData.append("parceiro", this.parceiro);

              seloDiagnosticoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.perguntaId].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            }
          } else {
            this.payload[children.grupoId][children.perguntaId].status =
              "success";
            this.statusGrupo(grupo, index);
            this.$forceUpdate();
          }
          console.log("Resposta salva com sucesso: ", data);
          this.payload[children.grupoId][children.perguntaId].respostaId =
            data.respostaId;
        })
        .catch((err) => {
          this.$notification.error("Ocorreu um erro ao salvar a resposta.");

          console.log("err: ", err);
          this.payload[children.grupoId][children.perguntaId].status = "error";
          this.statusGrupo(grupo, index);
          this.$forceUpdate();
        });
    },
    downloadEvidencia(evidenciaId, pergunta, resposta) {
      // eslint-disable-next-line eqeqeq
      if (pergunta.tipoResposta == this.tipoDiagnostico.video) {
        let link = document.createElement("a");
        link.href = resposta.url;
        link.target = "_blank";
        link.click();
      } else {
        seloDiagnosticoEvidenciasAPI
          .download(evidenciaId, this.uf, this.parceiro)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: resp.headers["content-type"],
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },
    grupoCompleto(grupo) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      // eslint-disable-next-line eqeqeq
      return valoresGrupo.every((item) => {
        let pergunta = grupo.children.filter(
          (val) => val.perguntaId == item.perguntaId
        )[0];
        return item.status == "success";
      });
    },
    filteredItems() {
      this.setLoading(true);

      seloDiagnosticoPerguntasAPI
        .getPerguntas(this.uf, this.parceiro)
        .then((val) => {
          this.allPerguntas = val.data.map((item) => {
            return {
              ...item,
              opcoesMultiplaEscolha: item.opcoesMultiplaEscolha
                ? item.opcoesMultiplaEscolha.split(", ")
                : null,
            };
          });

          let groupBy = this.allPerguntas;

          let key = "grupoId";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.perguntas = Object.keys(aux).map((key) => {
            return {
              grupoId: key,
              name: aux[key] && aux[key][0].grupoNome,
              children: aux[key],
            };
          });

          this.municipioInfo();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter perguntas");

          console.log("filteredItems err: ", err);
          this.setLoading(false);
        });
    },
    deleteFile(evidenciaId, children) {
      this.payload[children.perguntaGrupoId][children.perguntaId].status =
        "loading";

      seloDiagnosticoEvidenciasAPI
        .deleteEvidencia(evidenciaId, this.uf, this.parceiro)
        .then(() => {
          if (children.files && children.files.length > 0) {
            children.files.forEach((file, index) => {
              // eslint-disable-next-line eqeqeq
              if (file.evidenciaId == evidenciaId) {
                children.files.splice(index, 1);
              }
            });
          }

          this.payload[children.perguntaGrupoId][children.perguntaId].files =
            children.files;
          // eslint-disable-next-line eqeqeq
          if (!children.files || children.files.length == 0) {
            seloDiagnosticoRespostaAPI
              .delete(
                this.payload[children.perguntaGrupoId][children.perguntaId]
                  .respostaId,
                this.uf,
                this.parceiro
              )
              .then(() => {
                this.filteredItems();
              })
              .catch((err) => {
                console.log(
                  "diagnosticoSelo/List deleteFile delete resposta ",
                  err
                );
                this.$notification.error("Erro ao excluir o arquivo");
              });
          } else {
            this.filteredItems();
          }
        })
        .catch((err) => {
          console.log("diagnosticoSelo/List deleteFile delete file", err);
          this.$notification.error("Erro ao excluir o arquivo");
        });
    },
    podeContinuarInscricao(seloDiagnosticoResponsaveis, user) {
      if (
        this.isAuthenticated &&
        seloDiagnosticoResponsaveis &&
        seloDiagnosticoResponsaveis.length > 0
      ) {
        var user3 = JSON.parse(localStorage.getItem("user") || "{}");

        var usuarioPossuiEmail = seloDiagnosticoResponsaveis.some(
          (item) =>
            item.resposta.resposta ==
            ((user && user.email) ||
              (this.user && this.user.email) ||
              (user3 && user3.email))
        );

        if (usuarioPossuiEmail || this.isFullAdmin) {
          this.podeContinuar = true;

          this.mapRespostas();
        } else {
          this.podeContinuar = false;
        }
      } else if (seloDiagnosticoResponsaveis.length == 0) {
        this.podeContinuar = true;
        this.mapRespostas();
      } else {
        this.podeContinuar = false;
      }
      this.$forceUpdate();
      this.setLoading(false);
    },
    municipioInfo(user) {
      this.setLoading(true);
      cityAPI
        .getPorUf(this.municipioId, this.uf, this.parceiro)
        .then((municipio) => {
          this.municipio = municipio.data;
          console.log("Municipio info: ", municipio.data, user);
          this.podeContinuarInscricao(
            municipio.data.seloDiagnosticoResponsaveis ||
              municipio.data.seloDiagnosticoResponsaveisParceiros,
            user
          );
        })
        .catch((err) => {
          console.log("daignosticoSelo/List municipioInfo ", err);
          this.$notification.error("Erro ao buscar municipio");
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    isEnviada() {
      if (this.bloquearInscricoesNovas) {
        return this.statusRelatorio == "Diagnóstico em preenchimento"
          ? false
          : true;
      }

      if (this.bloquearTodasInscricoes) return true;

      // eslint-disable-next-line eqeqeq
      if (this.allRespostas.length == 0) return false;
      if (this.allRespostas.every((item) => item.enviada)) return true;

      return false;
    },
    isRulesNeeded(pergunta, resposta) {
      if (pergunta.obrigatorio && !pergunta.dependente) return true;
      if (pergunta.dependente && pergunta.obrigatorio) {
        let dependente = this.payload[pergunta.grupoId][pergunta.dependente];
        if (dependente.resposta || dependente.resposta === false) return true;
        else return false;
      }

      return false;
    },
    async enviarAnalise() {
      if (
        this.bloquearInscricoesNovas &&
        this.statusRelatorio != "Diagnóstico em preenchimento"
      ) {
        return;
      }

      if (this.bloquearTodasInscricoes) return;
      var isValid = await this.check();

      console.log("isValid: ", isValid);

      // Primeiro validar campos de múltiplas escolhas
      const camposComErro = this.validarCamposMultiplasEscolhas();
      console.log(
        "Respostas de múltiplas escolhas antes de validar: ",
        camposComErro
      );

      const perguntaEmail = this.payload[3][12];
      const perguntaInsta = this.payload[3][15];

      const perguntaWhats = this.payload[3][18];

      if (
        perguntaEmail.resposta == false &&
        perguntaInsta.resposta == false &&
        perguntaWhats.resposta == false
      ) {
        this.$notification.error(
          "É obrigatório que pelo menos uma das perguntas 12, 15 e 18 sejam sim."
        );

        return;
        // } else if (
        //   perguntaEmail.resposta == false &&
        //   perguntaWhats.resposta == false
        // ) {
        //   Swal.fire({
        //     title: "Atenção",
        //     text: `Instituições que disponibilizam apenas o canal telefônico não serão pontuadas no critério de presença digital. Revisite as perguntas 12 e 18.`,
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33",
        //     cancelButtonText: "Cancelar",
        //     confirmButtonText: "Continuar",
        //     reverseButtons: true,
        //   }).then((result) => {
        //     if (!result.isConfirmed) {
        //       return;
        //     } else {
        //       if (!isValid) {
        //         const errorElement = document.querySelector(".error--text");
        //         errorElement.scrollIntoView({
        //           behavior: "smooth",
        //           block: "center",
        //           inline: "nearest",
        //         });
        //         return;
        //       }
        //       Swal.fire({
        //         title: "Finalizar inscrição",
        //         text: `Ao finalizar os dados não poderão ser alterados. Deseja continuar?`,
        //         showCancelButton: true,
        //         confirmButtonColor: "#3085d6",
        //         cancelButtonColor: "#d33",
        //         cancelButtonText: "Não",
        //         confirmButtonText: "Sim",
        //         reverseButtons: true,
        //       }).then((result) => {
        //         if (result.isConfirmed) {
        //           this.enviarAnaliseFim();
        //         }
        //       });
        //     }
        //   });
      } else {
        if (!isValid || camposComErro.length > 0) {
          const errorElement = document.querySelector(".error--text");
          errorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          return;
        }
        Swal.fire({
          title: "Finalizar inscrição",
          text: `Ao finalizar os dados não poderão ser alterados. Deseja continuar?`,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Não",
          confirmButtonText: "Sim",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.enviarAnaliseFim();
          }
        });
      }
    },
    temAlgumaSelecao(children) {
      // Verificar se há seleções no v-model dos checkboxes normais
      const checkboxStates =
        this.checkboxStates[`${children.grupoId}-${children.perguntaId}`] || [];
      const temSelecaoNormal = checkboxStates.length > 0;

      // Verificar se há seleção no checkbox especial
      const payloadResposta =
        this.payload[children.grupoId] &&
        this.payload[children.grupoId][children.perguntaId]
          ? this.payload[children.grupoId][children.perguntaId].resposta
          : null;
      const temSelecaoEspecial = Array.isArray(payloadResposta)
        ? payloadResposta.includes(children.nomeCampoNaoMultiplaEscolha)
        : payloadResposta === children.nomeCampoNaoMultiplaEscolha;

      return temSelecaoNormal || temSelecaoEspecial;
    },
    validarCamposMultiplasEscolhas() {
      let camposComErro = [];

      // Percorrer todos os grupos de perguntas
      for (const grupo of this.perguntas) {
        for (const children of grupo.children) {
          // Verificar apenas campos de múltiplas escolhas obrigatórias
          if (
            children.tipoResposta === this.tipoDiagnostico.multiplasEscolhas &&
            this.isRulesNeeded(
              children,
              this.payload[children.grupoId][children.perguntaId]
            )
          ) {
            if (children.dependente) {
              const dependenteResposta = children.dependente
                ? this.payload[children.grupoId][children.dependente].resposta
                : null;
              if (
                dependenteResposta === null ||
                dependenteResposta === undefined ||
                dependenteResposta === "Não"
              ) {
                this.payload[children.grupoId][children.perguntaId].status =
                  "success";
              }
            }
            // Verificar se alguma opção foi selecionada
            else if (!this.temAlgumaSelecao(children)) {
              // Marcar como erro
              this.payload[children.grupoId][children.perguntaId].status =
                "error";
              camposComErro.push(`Pergunta ${children.perguntaId}`);
            } else {
              // Remover erro se existir
              if (
                this.payload[children.grupoId][children.perguntaId].status ===
                "error"
              ) {
                this.payload[children.grupoId][children.perguntaId].status =
                  "success";
              }
            }
          }
        }
      }

      this.$forceUpdate();
      return camposComErro;
    },
    handleKeyDown(event, children) {
      // Permitir teclas de navegação essenciais
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Tab",
        "Escape",
      ];

      // Permitir Ctrl+V (colar), Ctrl+A (selecionar tudo), Ctrl+C (copiar), Ctrl+X (recortar)
      const isCtrlCombo =
        event.ctrlKey && ["v", "a", "c", "x"].includes(event.key.toLowerCase());

      // Permitir Cmd+V no Mac (colar), Cmd+A (selecionar tudo), Cmd+C (copiar), Cmd+X (recortar)
      const isCmdCombo =
        event.metaKey && ["v", "a", "c", "x"].includes(event.key.toLowerCase());

      // Se não é uma tecla permitida, nem combinação Ctrl/Cmd permitida, bloquear
      if (!allowedKeys.includes(event.key) && !isCtrlCombo && !isCmdCombo) {
        event.preventDefault();
      }
    },
    async avisoIniciarInscricao(save, isFile, children, grupo, index) {
      this.setLoading(true);

      // Buscar o e-mail da questão 3
      const emailResposta =
        this.payload[1] && this.payload[1][3]
          ? this.payload[1][3].resposta
          : "";

      const nomeUsuario =
        this.payload[1] && this.payload[1][1]
          ? this.payload[1][1].resposta
          : "";

      if (!emailResposta || emailResposta.trim() === "") {
        this.setLoading(false);
        this.$notification.error("E-mail não informado na questão 3.");
        return;
      }

      try {
        // Enviar código de validação automaticamente
        await userAPI.enviarCodigoValidacao({
          email: emailResposta,
          municipio: this.municipio.nome,
          municipioId: this.municipioId,
          uf: this.uf,
          parceiro: this.parceiro,
        });

        this.setLoading(false);
        console.log(
          "this.payload[1] && this.payload[1][3].respostaId ",
          this.payload[1] && this.payload[1][3].respostaId
        );
        // Mostrar modal única com código
        this.mostrarModalCodigoValidacao(
          emailResposta,
          3,
          this.payload[1] && this.payload[1][3].respostaId,
          1,
          nomeUsuario,
          save,
          isFile,
          children,
          grupo,
          index
        );
      } catch (error) {
        this.setLoading(false);
        console.error("Erro ao enviar código:", error);

        // Verificar se é erro de e-mail já existente
        if (error.response && error.response.status === 409) {
          Swal.fire({
            title: "E-mail já cadastrado",
            html: `
              <div style="text-align: left; margin: 20px 0;">
                <p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;">
                  O e-mail <strong style="color: #007bff;">${emailResposta}</strong> já está cadastrado no sistema.
                </p>
                <p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;">
                  Você será redirecionado para a tela de login para acessar sua conta.
                </p>
              </div>
            `,
            icon: "info",
            iconColor: "#007bff",
            showCancelButton: true,
            confirmButtonColor: "#007bff",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "🚀 Ir para Login",
            cancelButtonText: "❌ Fechar",
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
              confirmButton: "swal-custom-confirm",
              cancelButton: "swal-custom-cancel",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              this.logout();
              this.$router.push("/auth/login");
            }
          });
        } else {
          this.$notification.error(
            "Erro ao processar solicitação. Tente novamente."
          );
        }
      }
    },
    enviarAnaliseFim() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .enviarAnalise(this.municipioId, this.uf, this.parceiro)
        .then(() => {
          this.setLoading(false);
          this.filteredItems();
          this.$notification.success(
            "A sua inscrição foi finalizado com sucesso. Obrigado!"
          );
        })
        .catch((err) => {
          this.setLoading(false);

          this.$notification.error("Erro ao enviar para analise");
          console.log("diagnosticoselo/list enviarAnalise ", err);
        });
    },
    back() {
      if (!this.isEnviada()) {
        Swal.fire({
          title: "A sua inscrição foi salva",
          text: `Lembramos que não foi finalizada`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/cidade/" + this.municipioId);
          }
        });
      } else {
        this.$router.push("/cidade/" + this.municipioId);
      }
    },
    async mostrarModalCodigoValidacao(
      email,
      diagnosticoPerguntaId,
      diagnosticoRespostaId,
      diagnosticoGrupoId,
      nomeUsuario,
      save,
      isFile,
      children,
      grupo,
      index
    ) {
      const { value: codigo } = await Swal.fire({
        title: "📧 Validação de E-mail",
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;">
              <strong>Importante:</strong> O e-mail que será utilizado para as próximas ações tanto na inscrição quanto nas demais etapas do <strong>Selo 2026</strong> é o informado na questão 3:
            </p>
            <div style="background: #f8f9fa; border-left: 4px solid #007bff; padding: 15px; border-radius: 5px; margin: 15px 0;">
              <p style="margin: 0; font-size: 18px; font-weight: bold; color: #007bff;">
                Email: ${email}
              </p>
            </div>
            <p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;">
              Um código de validação foi enviado para este e-mail. Digite o código de 6 dígitos abaixo para confirmar:
            </p>
            <p style="margin: 15px 0; font-size: 14px; color: #6c757d; background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 10px;">
              <i class="mdi mdi-information"></i> <strong>Após validar:</strong> Este e-mail será vinculado à sua inscrição e você precisará fazer login com ele para continuar o processo. Certifique-se de que está correto!
            </p>
            <div style="margin: 15px 0;">
              <button onclick="reenviarCodigo()" style="background: none; border: none; color: #007bff; text-decoration: underline; cursor: pointer; font-size: 14px;">
                🔄 Reenviar código
              </button>
            </div>
          </div>
        `,
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
          placeholder: "000000",
          maxlength: "6",
          style:
            "text-align: center; font-size: 24px; letter-spacing: 8px; font-weight: bold;",
        },
        showCancelButton: true,
        confirmButtonText: "Confirmar e Vincular",
        cancelButtonText: "❌ Cancelar",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        customClass: {
          popup: "swal-custom-popup",
          title: "swal-custom-title",
          confirmButton: "swal-custom-confirm",
          cancelButton: "swal-custom-cancel",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Digite o código de validação!";
          }
          if (!/^\d{6}$/.test(value)) {
            return "O código deve ter exatamente 6 dígitos!";
          }
        },
        didOpen: () => {
          // Adicionar função global para reenvio
          window.reenviarCodigo = async () => {
            try {
              this.setLoading(true);
              await userAPI.enviarCodigoValidacao({
                email: email,
                municipio: this.municipio.nome,
                uf: this.uf,
                parceiro: this.parceiro,
              });
              this.setLoading(false);
              this.$notification.success("Código reenviado com sucesso!");
            } catch (error) {
              this.setLoading(false);
              console.error("Erro ao reenviar código:", error);
              this.$notification.error(
                "Erro ao reenviar código. Tente novamente."
              );
            }
          };
        },
        willClose: () => {
          // Limpar função global
          delete window.reenviarCodigo;
        },
      });

      if (codigo) {
        await this.validarCodigoECriarUsuario(
          email,
          codigo,
          diagnosticoPerguntaId,
          diagnosticoRespostaId,
          diagnosticoGrupoId,
          nomeUsuario,
          save,
          isFile,
          children,
          grupo,
          index
        );
      }
    },
    async validarCodigoECriarUsuario(
      email,
      codigo,
      diagnosticoPerguntaId,
      diagnosticoRespostaId,
      diagnosticoGrupoId,
      nomeUsuario,
      save,
      isFile,
      children,
      grupo,
      index
    ) {
      this.setLoading(true);

      try {
        // Primeiro verificar se o código é válido

        // Código válido, agora criar o usuário
        const criarUsuarioResult = await userAPI.criarComSenhaTemporaria({
          email: email,
          municipio: this.municipio.nome,
          uf: this.uf,
          parceiro: this.parceiro,
          codigoValidacao: codigo,
          diagnosticoPerguntaId: diagnosticoPerguntaId,
          diagnosticoRespostaId: diagnosticoRespostaId,
          diagnosticoGrupoId: diagnosticoGrupoId,
          nomeUsuario: nomeUsuario,
        });

        this.setLoading(false);

        if (criarUsuarioResult.data) {
          if (save && children && grupo)
            this.atualizar(save, isFile, children, grupo, index);

          const resultado = criarUsuarioResult.data;

          // Verificar se é usuário novo (precisa definir senha)
          if (resultado.usuarioNovo) {
            // Mostrar modal de sucesso e pedir para definir senha
            Swal.fire({
              title: "E-mail Validado!",
              html:
                '<div style="text-align: left; margin: 20px 0;">' +
                '<p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;"><strong>Parabéns!</strong> O e-mail foi validado com sucesso e você foi adicionado como responsável pela inscrição do <strong>Selo 2026</strong>.</p>' +
                '<div style="background: #e8f5e8; border-left: 4px solid #28a745; padding: 15px; border-radius: 5px; margin: 15px 0;"><p style="margin: 0; font-size: 18px; font-weight: bold; color: #28a745;">Email: ' +
                email +
                '</p><p style="margin: 5px 0 0 0; font-size: 14px; color: #28a745;">Este e-mail agora está vinculado à sua inscrição</p></div>' +
                '<div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 15px; margin: 15px 0;"><p style="margin: 0; font-size: 14px; color: #856404;"><strong>Próximo passo:</strong></p><p style="margin: 10px 0 0 0; font-size: 14px; color: #856404;">Como é seu primeiro acesso, você precisa definir uma senha pessoal para acessar sua conta.</p></div>' +
                "</div>",
              icon: "success",
              iconColor: "#28a745",
              confirmButtonColor: "#007bff",
              confirmButtonText: "Definir Senha",
              allowOutsideClick: false,
              allowEscapeKey: false,
              customClass: {
                popup: "swal-custom-popup",
                title: "swal-custom-title",
                confirmButton: "swal-custom-confirm",
              },
            }).then(() => {
              this.mostrarModalDefinirSenha(email);
            });
          } else {
            // Usuário existente - fluxo normal
            Swal.fire({
              title: "E-mail Validado!",
              html:
                '<div style="text-align: left; margin: 20px 0;">' +
                '<p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;"><strong>Sucesso!</strong> O e-mail foi validado e você foi adicionado como responsável pela inscrição do <strong>Selo 2026</strong>.</p>' +
                '<div style="background: #e8f5e8; border-left: 4px solid #28a745; padding: 15px; border-radius: 5px; margin: 15px 0;"><p style="margin: 0; font-size: 18px; font-weight: bold; color: #28a745;">Email: ' +
                email +
                '</p><p style="margin: 5px 0 0 0; font-size: 14px; color: #28a745;">Este e-mail agora está vinculado à sua inscrição</p></div>' +
                '<div style="background: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 15px 0;">' +
                '<p style="margin: 0; font-size: 14px; color: #0c5460;"><strong>Próximos passos:</strong></p>' +
                '<ul style="margin: 10px 0; padding-left: 20px; font-size: 14px; color: #0c5460;">' +
                "<li>Use este e-mail para fazer login no sistema</li>" +
                '<li>Se não souber a senha, clique em "Esqueci minha senha" na tela de login</li>' +
                "<li>A partir de agora, somente este e-mail será responsável por continuar o processo de inscrição</li>" +
                "</ul>" +
                "</div>" +
                '<p style="margin-top: 15px; font-size: 14px; color: #6c757d; text-align: center;">' +
                '<i class="mdi mdi-information"></i> Você será redirecionado para a tela de login' +
                "</p>" +
                "</div>",
              icon: "success",
              iconColor: "#28a745",
              confirmButtonColor: "#28a745",
              confirmButtonText: "🚀 Ir para Login",
              cancelButtonColor: "#6c757d",
              cancelButtonText: "Fechar",
              showCancelButton: true,
              customClass: {
                popup: "swal-custom-popup",
                title: "swal-custom-title",
                confirmButton: "swal-custom-confirm",
                cancelButton: "swal-custom-cancel",
              },
            }).then((result) => {
              if (result.isConfirmed) {
                this.irParaLogin();
              } else if (result.isDismissed) {
                this.municipioInfo();
              }
            });
          }
        }
      } catch (error) {
        this.setLoading(false);
        console.error("Erro ao validar código:", error);

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (
            error.response.data.message.includes("inválido") ||
            error.response.data.message.includes("expirado")
          ) {
            Swal.fire({
              title: "Código Inválido",
              html: `
                <div style="text-align: center; margin: 20px 0;">
                  <p style="margin-bottom: 15px; font-size: 16px; color: #dc3545;">
                    O código informado é inválido ou expirou.
                  </p>
                  <p style="margin-bottom: 15px; font-size: 14px; color: #6c757d;">
                    Tente novamente com um código válido ou solicite um novo código.
                  </p>
                </div>
              `,
              icon: "error",
              iconColor: "#dc3545",
              showCancelButton: true,
              confirmButtonColor: "#007bff",
              cancelButtonColor: "#6c757d",
              confirmButtonText: "🔄 Tentar Novamente",
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.isConfirmed) {
                // Reabrir modal de código
                this.mostrarModalCodigoValidacao(email);
              }
            });
          } else {
            this.$notification.error("Erro: " + error.response.data.message);
          }
        } else {
          this.$notification.error("Erro ao validar código. Tente novamente.");
        }
      }
    },
    async mostrarModalDefinirSenha(email) {
      // Primeiro verificar se o usuário realmente precisa definir senha
      try {
        const verificacao = await userAPI.verificarPrimeiroCadastro({ email });

        if (!verificacao.data.primeiroCadastro) {
          // Usuário já definiu senha, redirecionar para login
          this.irParaLogin();
          return;
        }
      } catch (error) {
        console.error("Erro ao verificar primeiro cadastro:", error);
        this.irParaLogin();
        return;
      }

      const { value: formValues } = await Swal.fire({
        title: "Criar Senha",
        html:
          "<style>" +
          ".password-container { position: relative; margin: 15px 0; }" +
          ".password-input { width: 100% !important; padding: 12px 45px 12px 16px !important; border: 2px solid #e9ecef !important; border-radius: 10px !important; font-size: 14px !important; transition: all 0.3s ease !important; box-sizing: border-box !important; margin: 0 !important; }" +
          ".password-input:focus { border-color: #007bff !important; box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15) !important; outline: none !important; }" +
          ".password-toggle { position: absolute; right: 12px; top: 65%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #6c757d; font-size: 16px; padding: 5px; border-radius: 4px; transition: all 0.2s ease; font-weight: bold; }" +
          ".password-toggle:hover { color: #007bff; background-color: rgba(0, 123, 255, 0.1); }" +
          ".input-label { display: block; margin-bottom: 8px; font-weight: 600; color: #495057; font-size: 14px; }" +
          ".password-requirements { background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border: 1px solid #dee2e6; border-radius: 8px; padding: 12px; margin: 20px 0; font-size: 12px; color: #6c757d; }" +
          ".email-display { background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-left: 4px solid #2196f3; padding: 15px; border-radius: 8px; margin: 15px 0; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }" +
          "</style>" +
          '<div style="text-align: left; margin: 20px 0;">' +
          '<p style="margin-bottom: 20px; font-size: 16px; color: #2c3e50; line-height: 1.5;"><strong>Quase pronto!</strong> Para concluir seu cadastro, crie uma senha segura para sua conta:</p>' +
          '<div class="email-display"><p style="margin: 0; font-size: 14px; color: #1976d2; font-weight: 500;">Email: <strong>' +
          email +
          "</strong></p></div>" +
          '<div class="password-container"><label class="input-label">Nova Senha:</label><input id="novaSenha" type="password" class="password-input" placeholder="Digite sua senha forte"><button type="button" class="password-toggle" onclick="togglePassword(\'novaSenha\')" title="Mostrar/Esconder senha">Mostrar</button></div>' +
          '<div class="password-requirements"><div style="font-weight: 600; margin-bottom: 8px; color: #495057;">Requisitos da senha:</div><div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; font-size: 11px;"><div>• Mínimo 8 caracteres</div><div>• Uma letra maiúscula</div><div>• Uma letra minúscula</div><div>• Um caractere especial</div></div></div>' +
          '<div class="password-container"><label class="input-label">Confirmar Senha:</label><input id="confirmarSenha" type="password" class="password-input" placeholder="Confirme sua senha"><button type="button" class="password-toggle" onclick="togglePassword(\'confirmarSenha\')" title="Mostrar/Esconder senha">Mostrar</button></div>' +
          '<div style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%); border: 1px solid #4caf50; border-radius: 8px; padding: 12px; margin: 20px 0; box-shadow: 0 2px 4px rgba(76,175,80,0.2);"><p style="margin: 0; font-size: 13px; color: #2e7d32; font-weight: 500;"><strong>Dica de Segurança:</strong> Use uma combinação única de letras, números e símbolos. Evite informações pessoais como datas de nascimento.</p></div>' +
          "</div>",
        icon: "key",
        showCancelButton: true,
        confirmButtonText: "Criar Senha",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#007bff",
        cancelButtonColor: "#6c757d",
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          popup: "swal-custom-popup",
          title: "swal-custom-title",
          confirmButton: "swal-custom-confirm",
          cancelButton: "swal-custom-cancel",
        },
        didOpen: () => {
          // Adicionar função global para toggle de senha
          window.togglePassword = function (inputId) {
            var input = document.getElementById(inputId);
            var button = input.nextElementSibling;
            if (input.type === "password") {
              input.type = "text";
              button.innerHTML = "Ocultar";
              button.title = "Esconder senha";
            } else {
              input.type = "password";
              button.innerHTML = "Mostrar";
              button.title = "Mostrar senha";
            }
          };
        },
        willClose: () => {
          // Limpar função global
          delete window.togglePassword;
        },
        preConfirm: () => {
          const novaSenha = document.getElementById("novaSenha").value;
          const confirmarSenha =
            document.getElementById("confirmarSenha").value;

          // Validação de senha forte
          const senhaRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

          if (!novaSenha) {
            Swal.showValidationMessage("Digite uma senha");
            return false;
          }

          if (novaSenha.length < 8) {
            Swal.showValidationMessage(
              "A senha deve ter pelo menos 8 caracteres"
            );
            return false;
          }

          if (!senhaRegex.test(novaSenha)) {
            Swal.showValidationMessage(
              "A senha deve conter: pelo menos 1 letra maiúscula, 1 minúscula, 1 número e 1 caractere especial (@$!%*?&)"
            );
            return false;
          }

          if (novaSenha !== confirmarSenha) {
            Swal.showValidationMessage("As senhas não coincidem");
            return false;
          }

          return { novaSenha };
        },
      });

      if (formValues) {
        await this.definirSenhaPrimeiroAcesso(email, formValues.novaSenha);
      } else {
        // Usuário cancelou, redirecionar para login mesmo assim
        this.irParaLogin();
      }
    },
    async definirSenhaPrimeiroAcesso(email, novaSenha) {
      this.setLoading(true);

      try {
        const resultado = await userAPI.definirSenhaPrimeiroAcesso({
          email,
          novaSenha,
        });

        this.setLoading(false);

        Swal.fire({
          title: "Senha Criada!",
          html:
            '<div style="text-align: left; margin: 20px 0;">' +
            '<p style="margin-bottom: 15px; font-size: 16px; color: #2c3e50;"><strong>Perfeito!</strong> Sua senha foi criada com sucesso.</p>' +
            '<div style="background: #e8f5e8; border-left: 4px solid #28a745; padding: 15px; border-radius: 5px; margin: 15px 0;">' +
            '<p style="margin: 0; font-size: 16px; color: #28a745;">✅ <strong>Conta ativada com sucesso!</strong></p>' +
            '<p style="margin: 5px 0 0 0; font-size: 14px; color: #28a745;">Agora você pode fazer login normalmente</p>' +
            "<\/div>" +
            '<div style="background: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 15px 0;">' +
            '<p style="margin: 0; font-size: 14px; color: #0c5460;"><strong>Credenciais de acesso:</strong></p>' +
            '<p style="margin: 8px 0; font-size: 14px; color: #0c5460;">Email: ' +
            email +
            "</p>" +
            '<p style="margin: 8px 0; font-size: 14px; color: #0c5460;">🔑 <strong>Senha:</strong> (a que você acabou de criar)</p>' +
            "<\/div>" +
            '<p style="margin-top: 15px; font-size: 14px; color: #6c757d; text-align: center;"><i class="mdi mdi-login"><\/i> Você será redirecionado para fazer login</p>' +
            "<\/div>",
          icon: "success",
          iconColor: "#28a745",
          confirmButtonColor: "#28a745",
          confirmButtonText: "Continuar inscrição",
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            popup: "swal-custom-popup",
            title: "swal-custom-title",
            confirmButton: "swal-custom-confirm",
          },
        }).then(() => {
          this.login(email, novaSenha);
        });
      } catch (error) {
        this.setLoading(false);
        console.error("Erro ao definir senha:", error);

        let mensagemErro = "Erro ao criar senha. Tente novamente.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          mensagemErro = error.response.data.message;
        }

        Swal.fire({
          title: "Erro",
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p style="margin-bottom: 15px; font-size: 16px; color: #dc3545;">
                ${mensagemErro}
              </p>
              <p style="margin-bottom: 15px; font-size: 14px; color: #6c757d;">
                Tente novamente ou entre em contato com o suporte.
              </p>
            </div>
          `,
          icon: "error",
          iconColor: "#dc3545",
          showCancelButton: true,
          confirmButtonColor: "#007bff",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "🔄 Tentar Novamente",
          cancelButtonText: "Ir para Login",
        }).then((result) => {
          if (result.isConfirmed) {
            // Tentar novamente
            this.mostrarModalDefinirSenha(email);
          } else {
            // Ir para login mesmo com erro
            this.irParaLogin();
          }
        });
      }
    },
    irParaLogin() {
      if (this.isAuthenticated) {
        this.setForcedLogout(true);
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/auth/login");
        });
      } else {
        this.$router.push("/auth/login");
      }
    },
    irParaCadastro() {
      this.$router.push("/auth/cadastro");
    },
    login(email, senha) {
      this.setLoading(true);
      this.$http
        .post("api/login", { email, senha })
        .then(async ({ data }) => {
          if (data.user) {
            delete data.user.senha;
            const mappedUser = {
              ...data.user,
              permissoes: data.user.permissoes.map((item) => ({
                ...item,
                municipio: {},
              })),
            };

            this.setUser(mappedUser);

            this.setForcedLogout(false);
            if (data.user.email === "admin@admin.com.br")
              this.setFullAdmin(true);

            this.setToken(data.accessToken);

            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.token}`;
            await this.$nextTick();

            const config = await configuracoesAPI.get();
            const groupPermission = await groupsPermissionAPI.getByGroup(
              data.user.grupo.usuarioGrupoId
            );

            const configData = config.data.filter(
              (item) => item.configuracaoId == 1
            )[0];

            delete configData.relatorioFinal;
            this.setConfig(configData);
            this.setGroupsConfig(groupPermission.data);

            // Após login bem-sucedido, atualizar informações do município
            // para reconhecer o usuário como responsável e mostrar todas as perguntas
            console.log("Login bem-sucedido, dados do usuário: ", data.user);

            // Aguardar o próximo tick do Vue para garantir que o localStorage foi atualizado
            this.municipioInfo(data.user);
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
            this.setLoading(false);
          }
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.usuarioBloqueado) {
            this.$notification.error(err.response.data.message, {
              timer: 10,
            });
          } else if (err.response && err.response.data.credencialErrada) {
            this.$notification.error(
              "Por gentileza, verifique as credenciais digitadas",
              { timer: 5 }
            );
          } else {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
          }
          this.setForcedLogout(true);
        });
    },
  },
  async mounted() {
    const config = await configuracoesAPI.get();

    this.bloquearTodasInscricoes =
      config.data.find((item) => item.configuracaoId == 13).valor === "true";

    this.bloquearInscricoesNovas =
      config.data.find((item) => item.configuracaoId == 14).valor === "true";
  },
  beforeMount() {
    if (this.isParceiro) {
      this.idPerguntaCoringa = 115;

      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/geral`,
          exact: true,
        },
        {
          text: "Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/diagnostic/selo`,
          exact: true,
        },
      ];
    }
    this.filteredItems();
  },
  computed: {
    ...mapGetters([
      "isSala",
      "isFullAdmin",
      "isParceiro",
      "isAuthenticated",
      "isLoading",
    ]),
    possuiResponsavel() {
      return (
        (this.municipio &&
          this.municipio.seloDiagnosticoResponsaveis &&
          this.municipio.seloDiagnosticoResponsaveis.length > 0) ||
        (this.municipio &&
          this.municipio.seloDiagnosticoResponsaveisParceiros &&
          this.municipio.seloDiagnosticoResponsaveisParceiros.length > 0)
      );
    },
    // Computed property para forçar reatividade dos checkboxes
    checkboxStates: {
      get() {
        const states = {};
        if (!this.payload) return states;

        Object.keys(this.payload).forEach((grupoId) => {
          if (!this.payload[grupoId]) return;

          Object.keys(this.payload[grupoId]).forEach((perguntaId) => {
            if (!this.payload[grupoId][perguntaId]) return;

            const key = `${grupoId}-${perguntaId}`;
            let resposta = this.payload[grupoId][perguntaId].resposta;

            // Se é string (veio do backend como "MEI, Microempresa"), converter para array
            if (typeof resposta === "string" && resposta.trim()) {
              resposta = resposta
                .split(", ")
                .filter((item) => item.trim().length > 0);
            }

            // Normalizar todos os valores para string para garantir comparação consistente
            states[key] = Array.isArray(resposta)
              ? resposta.map((item) => String(item))
              : [];
          });
        });

        return states;
      },
      set(newStates) {
        // O setter será automaticamente chamado pelo v-model
        // Mas vamos implementar apenas para compatibilidade
        Object.keys(newStates).forEach((key) => {
          const [grupoId, perguntaId] = key.split("-");
          if (this.payload[grupoId] && this.payload[grupoId][perguntaId]) {
            this.$set(
              this.payload[grupoId][perguntaId],
              "resposta",
              newStates[key]
            );
          }
        });
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitulo {
  font-size: 14px;
  font-weight: bold;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  margin-top: 1rem;
}
.grupo {
  margin-bottom: 1rem;
}

.enviada {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
  margin: 2rem;
  font-size: 20px;
  /* font-weight: bold; */
  background: #606060;
  border-radius: 19px;
  padding: 10px;
  color: #fff;
  margin: 2rem auto;
  align-items: center;
  column-gap: 10px;
}

.salvar {
  color: #0c6b10;
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.status {
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.salvarErro {
  color: #ff5252;
}

.bloco {
  position: sticky;
  top: 0;
  background: #2d6189;
  color: #fff;
  padding: 10px;
  z-index: 2;
  display: flex;
  column-gap: 10px;
  cursor: pointer;
}
.completed {
  background: #0c6b10;
}

.error {
  background: #ff5252;
}

.inProgress {
  background: #f57d30;
  color: #fff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.38);
}

.children {
  border: 1px solid #c1bebe8c;
  position: relative;
  .filho {
    display: flex;
  }
}
.children {
  padding: 10px;

  .numeration {
    font-weight: bold;
    font-size: 14px;
  }
}

// Estilos para checkboxes com erro
::v-deep .checkbox-error {
  .v-label {
    color: #ff5252 !important;
  }

  .v-icon {
    color: #ff5252 !important;
  }
}

// Estilos personalizados para Swal
::v-deep .swal-custom-popup {
  border-radius: 15px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .swal-custom-title {
  color: #2c3e50 !important;
  font-size: 24px !important;
  font-weight: 600 !important;
}

::v-deep .swal-custom-confirm {
  border-radius: 25px !important;
  padding: 12px 30px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3) !important;
  transition: all 0.3s ease !important;
}

::v-deep .swal-custom-confirm:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4) !important;
}

::v-deep .swal-custom-cancel {
  border-radius: 25px !important;
  padding: 12px 30px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

::v-deep .swal-custom-cancel:hover {
  transform: translateY(-2px) !important;
}

// Estilos para inputs customizados no Swal
::v-deep .swal2-input {
  border-radius: 8px !important;
  border: 2px solid #e9ecef !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  margin: 8px 0 !important;
  transition: border-color 0.3s ease !important;
}

::v-deep .swal2-input:focus {
  border-color: #007bff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  outline: none !important;
}

::v-deep .swal2-validation-message {
  background: #f8d7da !important;
  color: #721c24 !important;
  border: 1px solid #f5c6cb !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  padding: 8px 12px !important;
  margin-top: 8px !important;
}

/* Estilo singelo para avisos compactos */
.aviso-compacto {
  border-radius: 8px !important;
}

.aviso-compacto .v-alert__content {
  padding: 12px !important;
}

.aviso-compacto .text-caption {
  font-size: 13px !important;
  line-height: 1.4 !important;
}
</style>
